import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { _log } from '@shared/aux_helper_environment';
// eslint-disable-next-line @typescript-eslint/no-require-imports
const _marked = require('marked') as any;
const markedParse: (src: string) => string = (src: string) => _marked.marked(src) ?? _marked.parse(src);
const markedUse: (ext: any) => void = (ext: any) => (_marked.use ?? _marked.marked?.use)(ext);

/** Convierte una cadena CSV a una tabla HTML con clase .csv-table */
function csvToHtmlTable(csv: string): string {
  const lines = csv
    .trim()
    .split('\n')
    .filter(l => l.trim());
  if (lines.length === 0) return '<pre><code></code></pre>';
  const headers = lines[0].split(',').map(h => h.trim());
  const headerHtml = `<thead><tr>${headers.map(h => `<th>${h}</th>`).join('')}</tr></thead>`;
  const bodyHtml = `<tbody>${lines
    .slice(1)
    .map(line => {
      const cells = line.split(',').map(c => c.trim());
      return `<tr>${cells.map(c => `<td>${c}</td>`).join('')}</tr>`;
    })
    .join('')}</tbody>`;
  return `<table class="csv-table">${headerHtml}${bodyHtml}</table>`;
}

/** Registra el renderer CSV en marked (idempotente) */
let _markdownConfigured = false;
function configureMarked(): void {
  if (_markdownConfigured) return;
  _markdownConfigured = true;

  // En marked v15+ el renderer recibe el token como objeto
  markedUse({
    breaks: true,
    gfm: true,
    renderer: {
      code(token: any): string | false {
        const lang: string = token.lang || token.language || '';
        if (lang === 'csv') {
          return csvToHtmlTable(token.text ?? token.code ?? '');
        }
        return false; // delega al renderer por defecto
      },
    },
  });
}

/**
 * Convierte Markdown a HTML string puro.
 * Útil fuera del contexto Angular (ej. downloadAsPdf).
 */
export function markdownToHtmlString(value: string): string {
  configureMarked();
  if (!value) return '';
  try {
    return markedParse(value) as string;
  } catch (e) {
    return value.replace(/\n/g, '<br>');
  }
}

@Pipe({
  name: 'markdown',
})
export class MarkdownPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
    configureMarked();
  }

  transform(value: string): SafeHtml {
    if (false) _log('[MarkdownPipe] Transforming value:', value);

    if (!value) return '';

    try {
      const html = markedParse(value) as string;
      return this.sanitizer.bypassSecurityTrustHtml(html);
    } catch (error) {
      console.error('[MarkdownPipe] Error parsing markdown:', error);
      return this.sanitizer.bypassSecurityTrustHtml(value.replace(/\n/g, '<br>'));
    }
  }
}
